
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'bootstrap-daterangepicker/daterangepicker.css';
import daterangepicker from 'bootstrap-daterangepicker';
import * as echarts from 'echarts';


window._ = require('lodash');
window.moment = require('moment');


try {
   
    window.$ = window.jQuery = $;
    window.daterangepicker = daterangepicker;
    require('datatables.net-bs4');
    require('./validations/jquery.validate.js');
    require('./validations/additional-methods.js');
    require('./theme/jquery-ui.min.js');
    require('./theme/jquery-clockpicker.min.js');// use clockpicker in timelog
    require('./theme/clockpicker.js');// custome features added in clockpicker
    require('./theme/alpine.min.js');
    require('./theme/app.js'); //theme side bar functionality
    require('./theme/index.min.js'); //theme UI feature enable here..
    require('./theme/jquery.ui.touch-punch.min.js');//enable touch on jquery 
    require('./theme/chosen.jquery.min.js');    
    require('./theme/select2.min.js');
    require('./theme/multiselect.min.js');
    require('./modules/comman.js');
    window.intlTelInput = require('./theme/intlTelInput.min.js');    
    window.toastr = require('toastr');
    // window.Chosen = require("chosenjs");
    window.Alpine = Alpine;
    window.echarts = echarts;

} catch (e) {
    console.log(e)
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
